import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';

import { pageConfigBySlug } from '../../../services/nav/NavigationService';
import { CornerIcon } from '../CornerIcon';

interface IProps {
  children?: React.ReactNode;
  image?: string;
  navPath: string;
  title: string;
  unlocked: boolean;
  alerts?: number;
  setUnlocked: (unlocked: boolean) => void;
  loading?: boolean;
}

export const UnlockedDashboardTile = (props: IProps) => {
  const {
    children,
    image,
    navPath,
    title,
    unlocked,
    loading,
  } = props;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleClick = () => {
    if (unlocked) {
      const basePath = `/${pageConfigBySlug("dashboard")?.slug || "dashboard"}`;
      const queryString = searchParams.toString();
      const finalPath = `${basePath}/${navPath}?${queryString}`;
      navigate(finalPath);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="flex relative z-0">
        <div className="text-[1.2rem] mr-5 relative text-zeos-black bg-white rounded-t px-3 py-1">
          {title}
          {/* {alerts && <ZeosAlertBadge amount={4} styles="-top-px -right-4" />} */}
        </div>
        {/* <div className="absolute right-0 z-10 flex items-center">
          <div
            onClick={() => {
              setUnlocked(!unlocked);
            }}
            className={`flex items-center w-8 h-4 bg-gray-500 rounded-full border-zeos-orange-lt border-2 cursor-pointer`}
          >
            <span
              className={`w-4 bg-white flex items-center h-4 rounded-full ${
                unlocked ? "ml-0" : "ml-4"
              } duration-100`}
            />
          </div>
        </div> */}
      </div>
      <div
        className={`relative group w-full ${
          !unlocked && "grayscale brightness-110"
        }`}
        onClick={handleClick}
      >
        <div className="h-[220px] w-full bg-white flex items-center cursor-pointer hover:ring-offset hover:ring-4 hover:ring-zeos-orange-dk">
          <div
            className={`${
              image ? "w-3/4" : "w-full"
            } h-full flex flex-col justify-center items-center`}
          >
            {loading ? (
              <ClipLoader color="#f97316" size={32} />
            ) : (
              children
            )}
          </div>
          {image && (
            <div className="w-1/2 h-full">
              <img
                className="h-[220px] w-full object-cover object-bottom"
                src={image}
                alt="image"
              />
            </div>
          )}
        </div>
        <CornerIcon unlocked={unlocked} />
      </div>
      {!unlocked && (
        <div className="flex justify-start items-center">
          <p className="text-xs">
            Discover how battery energy storage can improve your operations.{" "}
            <a className="cursor-pointer">Learn More</a>
          </p>
        </div>
      )}
    </div>
  );
};
